<script setup>
 import { ref, onMounted } from 'vue'
 import { useToast } from 'primevue/usetoast'

 const localePath = useLocalePath()
 const toast = useToast()
 const { t } = useI18n()
 const cookiesAccepted = ref(false)

 onMounted(() => {
   cookiesAccepted.value = localStorage.getItem('cookiesAccepted') === 'true'
   setTimeout(() => {
     showCookiesToast();
   }, 1000);
 })

 const showCookiesToast = () => {
   if (!cookiesAccepted.value) {
     toast.add({
       severity: 'info',
       group: 'cookies',
       closable: false,
       sticky: true,
     });
   }
 };
 
 const acceptCookies = () => {
   localStorage.setItem('cookiesAccepted', true)
   toast.removeGroup('cookies');
 }
</script>

<template>
    <PrimeToast position="bottom-left" group="cookies" close >
      <template #message>
        <div class="flex flex-col gap-2 p-2">
          <div class="flex justify-between items-center">
            <h5 class="m-0 text-lg font-semibold">{{ t('components.global.cookiesToast.title') }}</h5>
          </div>
          <div>
            <p class="m-0 text-sm">
              {{ t('components.global.cookiesToast.message') }}
            </p>
          </div>
          <div class="flex items-center justify-between gap-2 mt-2">
            <PrimeButton as="router-link" :to="localePath('/cookies')" link>{{ t('components.global.cookiesToast.cookiesPolicy') }}</PrimeButton>
            <PrimeButton :label="t('components.global.cookiesToast.accept')" severity="primary" @click="acceptCookies" />
          </div>
        </div>
      </template>
    </PrimeToast>
</template>

<style scoped>
 :deep(.p-toast-message-content) {
   padding: 0;
 }
 
 :deep(.p-toast-icon-close) {
   display: none;
 }
 
 :deep(.p-toast-message) {
   border-radius: 8px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
 }
</style>